import { PUBLIC_ROUTES } from "@/constants/routes";
import {
  getCompanyFromSubdomain,
  getLayoutSlugFromPath,
} from "@/utils/subdomain";

/**
 * Checks if the current route is a public route that doesn't require authentication
 * @param pathname - The current pathname (defaults to window.location.pathname)
 * @returns boolean - true if the route is public, false otherwise
 */
export function isPublicRoute(
  pathname: string = window.location.pathname
): boolean {
  console.log("🔍 RouteUtils: Checking if route is public:", pathname);

  // Check exact matches
  if (PUBLIC_ROUTES.includes(pathname)) {
    console.log("✅ RouteUtils: Route is PUBLIC (exact match):", pathname);
    return true;
  }

  // Check for book-meeting pattern: /book-meeting/programSlug/expertSlug
  const bookMeetingPattern = /^\/book-meeting\/[^/]+\/[^/]+$/;
  if (bookMeetingPattern.test(pathname)) {
    console.log(
      "✅ RouteUtils: Route is PUBLIC (book-meeting pattern):",
      pathname
    );
    return true;
  }

  // Check for subdomain-based booking system: {company}.slashexperts.com/{layout-slug}
  // Layout slug is optional - if not provided, the default template will be used
  const company = getCompanyFromSubdomain();
  if (company) {
    const layoutSlug = getLayoutSlugFromPath();
    const routeDesc = layoutSlug
      ? `${company}.domain/${layoutSlug}`
      : `${company}.domain (default template)`;
    console.log(
      "✅ RouteUtils: Route is PUBLIC (subdomain booking-system):",
      routeDesc
    );
    return true;
  }

  console.log("🔒 RouteUtils: Route is PRIVATE:", pathname);
  return false;
}
